import { ButtonTriggerEvent } from '../../../common/components';

export class ResizeImageModalActions {
    confirm: (event: ButtonTriggerEvent, image: string) => void;
    cancel?: () => void;
}

export class ResizeImageModalData {
    data: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/resize.image.modal/resize.image.modal.provider.ts